import dayjs from 'dayjs'
import type { DocumentContext } from 'next/document'

import { globalBoostrapPropsWrapper, globalBootstrap, GlobalBootstrapWrapper } from '~/utils/globalBootstrap'

import ChefsMenuListingPage, { chefsMenuDefaultFilterSettings } from '~/components/Listing/pages/ChefsMenuListingPage'
import { getReservableExtraListQueryVariables, PAGE_SIZE } from '~/components/Listing/pages/ChefsMenuListingPage/ChefsMenuListingPageUtils'
import { getClubConfig, redirectIfFeatureDisabledInConfig } from '~/config/clubConfig'
import { getCanonicalForPath, paths } from '~/constants'
import {
  AllTagsDocument,
  AllTagsQuery,
  AllTagsQueryVariables,
  ReservableExtraListDocument,
  ReservableExtraListQuery,
  ReservableExtraListQueryVariables,
  SelectedRegionDocument,
  SelectedRegionQuery,
} from '~/generated/graphql'
import Layout from '~/layout'
import { getDefaultMetadatas } from '~/layout/Head/HeadUtils'
import { gt } from '~/locale'

export const getServerSideProps = async (ctx: DocumentContext) => {
  const { apolloClient } = await globalBootstrap({ ctx })

  const clubConfig = getClubConfig()
  if (!clubConfig.chmEnabled) {
    return redirectIfFeatureDisabledInConfig
  }

  const currentDate = dayjs()
  const selectedRegionQueryResult = apolloClient.cache.readQuery<SelectedRegionQuery>({
    query: SelectedRegionDocument,
  })

  const selectedRegion = selectedRegionQueryResult?.selectedRegion

  const variables = getReservableExtraListQueryVariables({
    selectedRegion,
    filters: { tags: chefsMenuDefaultFilterSettings.tags },
    first: PAGE_SIZE,
  })
  const [
    { data },
    {
      data: { tags },
    },
  ] = await Promise.all([
    apolloClient.query<ReservableExtraListQuery, ReservableExtraListQueryVariables>({
      query: ReservableExtraListDocument,
      variables,
    }),
    apolloClient.query<AllTagsQuery, AllTagsQueryVariables>({ query: AllTagsDocument, variables: { regionId: selectedRegion?.id } }),
  ])

  return globalBoostrapPropsWrapper(
    { apolloClient },
    {
      props: {
        data,
        tags,
        availableDatesISOString: [],
        minDateISOString: currentDate.toISOString(),
      },
    }
  )
}

const WrappedPage = GlobalBootstrapWrapper(ChefsMenuListingPage)

WrappedPage.getLayout = function (page) {
  return (
    <Layout
      metadata={{
        ...getDefaultMetadatas(),
        title: gt.tp('ChefsMenuPage', '#ChefsMenu'),
        description: gt.tp('ChefsMenuPage', 'Discover new restaurants every day! Book the flagship menu for any occasion via #ChefsMenu.'),
        canonical: getCanonicalForPath(paths.chefsMenuOffers),
      }}>
      {page}
    </Layout>
  )
}

export default WrappedPage
